module.exports = __webpack_public_path__ + "static/duze-2-df7a4873c611ecc12c17ff236ae89054.jpeg";